import { API_URLS } from "../../../../utils/api-constants";
import { useGet } from "../../hooks";

export function useSheetData() {
  const getSheets = useGet([API_URLS.SHEETS, { hierarchy: true }]);

  return {
    isLoading: getSheets.isLoading,
    isError: getSheets.isError,
    data: getSheets.data || [],
  };
}
